export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/howItWorks1.1aa11cfd.svg","height":380,"width":592,"blurWidth":0,"blurHeight":0};